import { styled, css } from 'styled-components';
import { Media } from '../../../../../theme/Media';
export const Wrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${Media.smMin} {
    &:not(:last-child) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
    }

    &:last-child {
      border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
    }
  }

  @media ${Media.xsMax} {
    border-radius: 8px;
    flex-direction: column;
    align-items: stretch;

    &:first-child {
      margin-bottom: 8px;
    }

    &:not(:last-child) {
      margin-bottom: 8px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    &:last-child {
      margin-top: 8px;
    }
  }
`;
export const InnerWrapper = styled.div `
  padding: ${({ $increasedVerticalPadding }) => ($increasedVerticalPadding ? '24px' : '16px 24px')};
  display: flex;
  align-items: center;
  gap: 8px;

  @media ${Media.smMin} {
    flex-grow: 1;

    & > :nth-child(1) {
      order: 1;
    }

    & > :nth-child(2) {
      order: 2;
    }

    & > :nth-child(3) {
      order: 3;
    }

    & > :nth-child(4) {
      order: 4;
    }

    & > :nth-child(5) {
      order: 5;
    }
  }

  @media ${Media.xsMax} {
    width: 100%;
    padding: 8px 16px;

    ${({ $topBorder }) => $topBorder &&
    css `
        border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
      `}

    ${({ $withSorting }) => !$withSorting &&
    css `
        justify-content: space-between;

        & > :nth-child(1) {
          order: 2;
        }

        & > :nth-child(2) {
          order: 1;
        }

        & > :nth-child(3) {
          order: 3;
        }
      `}
  }
`;
export const PageInfoWrapper = styled.div `
  @media ${Media.smMin} {
    margin-left: auto;
  }

  @media ${Media.xsMax} {
    ${({ $mobileMlAuto }) => $mobileMlAuto &&
    css `
        margin-left: auto;
      `}
  }
`;
export const FiltersWrapper = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 24px;

  @media ${Media.xsMax} {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 16px;
  }
`;
export const BulkActionsWrapper = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 24px;

  @media ${Media.xsMax} {
    padding: 12px 16px;
    justify-content: flex-end;

    & > :first-child {
      margin-right: auto;
    }
  }
`;
